module.exports = __webpack_public_path__ + "static/02-d676f52d80eda4c4400d51ba16e8c067.jpg";